<template>
	<div class="row d-flex justify-content-center mt-1 mb-70">
		<div class="col-md-12" v-if="!error">
			<div class="main-card mb-3">
				<b-overlay no-wrap :show="loading"></b-overlay>
				<b-row>
					<b-col class="mb-2">
						<b-table-simple class="table striped" responsive small >
							<b-tbody>
								<b-tr>
									<b-th>Sales Channel Ref.</b-th>
									<b-th>Client</b-th>
									<b-th>Pickup Datetime</b-th>
									<b-th>pickup</b-th>
									<b-th>Dropoff</b-th>
								</b-tr>
								<b-tr>
									<b-td>{{ride.salesChannelReference}} </b-td>
									<b-td>{{viewModel.client.firstName +" "+viewModel.client.lastName }} </b-td>
									<b-td>{{ride.pickupDatetime}} </b-td>
									<b-td>{{ride.pickup.name}} </b-td>
									<b-td>{{ride.dropoff.name}} </b-td>
								</b-tr>
							</b-tbody>
						</b-table-simple>
					</b-col>
				</b-row>
				<b-row>
					<b-col class="col-md-12">
						<div class="main-card mb-3">
							<b-overlay :show="loading" no-wrap rounded></b-overlay>
							<h3 v-if="logsTrackStatus.length==0 && !loading">No se encontraron resultados</h3>
							<b-table v-else :items="logsTrackStatus" :fields ="colsTableLogs" class="table striped" responsive small>
								<template #cell(creationDatetime)="row">
									<date-label :date="row.item.creationDatetime"/>
								</template>
							</b-table>
						</div>

						<g-map :ref="'map-tracking-status'" v-if="logsTrackStatus.length>0" @mounted="gmapMounted()"></g-map>
					</b-col>
				</b-row>

				<hr>
				<b-row>
					<b-col
						class="col-md-1 col-12"
						v-if="$hasPermission('reservation.tracking.driver.add')"
					>
						<b-form-group label=".">
							<b-button
								variant="outline-success"
								@click="showNewDriverForm"
								><md-icon :icon="'person_add'"></md-icon
							></b-button>
						</b-form-group>
					</b-col>
					<b-form-group
						v-if="$hasPermission('reservation.tracking.assign')"
						class="col-md-4 col-12"
						label="Conductor:"
						description="Este dato sera distribuido (Ej. booking.com)"
					>
						<b-form-select
							:options="driversOpts"
							v-model="driverSelected"
						></b-form-select>
					</b-form-group>
					<b-col
						class="col-md-3 col-12"
						v-if="$hasPermission('reservation.tracking.assign')"
					>
						<b-form-group label=".">
							<b-button
								variant="outline-primary"
								@click="actions('assignDriver')"
								>Asignar driver</b-button
							>
						</b-form-group>
					</b-col>
					<b-col class="col-md-4 col-12">
						<b-card
							border-variant="primary"
							header="Driver Distribuido"
							header-bg-variant="primary"
							header-text-variant="white"
							align="center"
						>
							<b-card-body class="p-0">
								<b-card-text v-if="applyExternal">{{
									driverExternal.fullName
								}}</b-card-text>
								<b-card-text v-else class="text-danger"
									>No aplica</b-card-text
								>
							</b-card-body>
						</b-card>
					</b-col>
				</b-row>
				<b-row>
					<b-col class="col-md-5 mx-auto mt-2">
						<b-col class="text-center">
							<span>Tracking status:</span><br />
							<b-badge pill variant="primary" class="p-2">{{
								trackingStatusActual.text
							}}</b-badge
							><br />
							<md-icon
								:icon="'keyboard_double_arrow_down'"
							></md-icon>
						</b-col>
						<b-form-checkbox
							id="checkbox-1"
							class="text-center"
							v-if="trackingStatusActual.value == 'atPickup'"
							v-model="noShow"
						>
							No show
						</b-form-checkbox>
						<b-button
							v-if="
								!islastStatus &&
									$hasPermission(
										'reservation.tracking.changeStatus'
									)
							"
							class="mt-1"
							variant="outline-primary"
							block
							@click="showMsgBox()"
							>Actualizar a :
							<b>{{ trackingStatusNext.text }}</b></b-button
						>
					</b-col>
				</b-row>
			</div>
			<b-alert
				variant="warning"
				v-if="alert.show"
				show
				class="text-center"
				dismissible
			>
				{{ alert.text }}
			</b-alert>
		</div>
		<div class="col">
			<b-alert variant="danger" v-if="error" show class="text-center">
				No puede cargar debido a que la informacíon del ride es
				incorrecto,intente guardar los cambios antes de entrar al modulo
			</b-alert>
		</div>
		<b-modal
			:header-bg-variant="'info'"
			hide-footer
			ref="new-driver"
			size="md"
			:title="`Nuevo Conductor`"
		>
			<driverForm :supplierId="supplierId" @saved="driverSaved" />
		</b-modal>
	</div>
</template>

<script>
import api from "../../../../api.js";
import { mapState, mapMutations } from "vuex";
import driverForm from "./FormNewDriver";
import DateLabel from "../../../helpers/DateLabel.vue"
import gMap from "../../rate-plans/Map.vue"
export default {
	name: "trackingForm",
	components: { driverForm, DateLabel ,gMap },
	data() {
		const modelDriver = { fullName: "", id: "" };
		return {
			error: false,
			modelDriver: modelDriver,
			loading: false,
			dataDrivers: [],
			driverInternal: { ...modelDriver }, //SC driver
			driverExternal: { ...modelDriver }, //booking spreaded
			trackStatusLogs:[],
			applyExternal: false,
			tsTimeZone:null,
			driverSelectedOption: "",
			alert: { show: false, text: "" },
			noShow: false,
			colsTableLogs: [
				{ key: 'transportServiceTrackingStatus', label: 'Track. status' },
				{ key: 'creationDatetime', label: 'Date Time UTC' },
				{ key: 'creationDatetimeLocal', label: 'Date time Local'},
				{ key: 'latitude', label: 'Lat.' },
				{ key: 'longitude', label: 'Lng.' },
				{ key: 'driverName', label: 'Conductor' },
			]
		};
	},
	methods: {
		...mapMutations("reservation", ["SET_UPDATE_TRANSPORT_SERVICE"]),
		showNewDriverForm() {
			this.$refs["new-driver"].show();
		},
		hideNewDriverForm() {
			this.$refs["new-driver"].hide();
		},
		resetDistributed() {
			this.applyExternal = false;
			this.driverExternal = { ...this.modelDriver };
			this.driverInternal = { ...this.modelDriver };
			this.trackStatusLogs= [];
			return;
		},

		fetchDrivers() {
			this.dataDrivers = [];
			this.loading = true;
			api(this)
				.get("/tracking/supplier/" + this.supplierId + "/drivers")
				.then(res => {
					this.dataDrivers = res.data;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		fetchAssignedData() {
			this.resetDistributed();
			this.loading = true;
			api(this)
				.get("/tracking/driver/assigned/" + this.ride.id)
				.then(res => {
					this.applyExternal = res.data.applyExternal;
					this.driverExternal = res.data.driverExternal;
					this.driverInternal = res.data.driverInternal;
					this.trackStatusLogs = res.data.logsTrackingStatus;
					if (res.data.supplierId != this.ride.supplierId) {
						this.error = true;
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		actions(action) {
			let filters = { transportServiceId: this.ride.id };
			switch (action) {
				case "updateStatus":
					if (this.islastStatus) {
						this.$root.showAlert("Opción no valida", {
							variant: "danger"
						});
						return;
					}
					filters["trackingStatus"] = this.trackingStatusNext.value;
					break;
				case "assignDriver":
					if (this.driverSelectedOption == "") {
						this.$root.showAlert("Seleccione un conductor", {
							variant: "danger"
						});
						return;
					}
					if (this.driverSelectedOption === "default") {
						action = "restartDriver";
					}
					filters["driverId"] = this.driverSelectedOption;
					break;
				default:
					this.$root.showAlert("Opción no valida", {
						variant: "danger"
					});
					return;
			}
			this.loading = true;
			this.alert = { show: false, text: "" };
			api(this)
				.post("/tracking/actions/" + action, filters)
				.then(res => {
					let payload = {};
					switch (action) {
						case "updateStatus":
							payload = {
								index: this.index,
								data: {
									trackingStatus: this.trackingStatusNext
										.value
								}
							};
							this.SET_UPDATE_TRANSPORT_SERVICE(payload);

							break;
						case "assignDriver":
						case "restartDriver":
							setTimeout(() => {
								this.fetchAssignedData();
							}, 0);
							break;
					}
					this.$root.showAlert("Realizado con exito");
					if ("alert" in res.data) {
						this.alert = { show: true, text: res.data.alert[0] };
					}
				})
				.catch(this.$root.handleRequestError)
				.finally(() => {
					this.loading = false;
				});
		},
		showMsgBox() {
			this.boxTwo = "";
			this.$bvModal
				.msgBoxConfirm("¿Esta seguro que desea cambiar el status?.", {
					title: "Confirmación",
					size: "sm",
					buttonSize: "sm",
					okVariant: "primary",
					okTitle: "Si",
					cancelTitle: "Cancelar",
					footerClass: "p-2",
					hideHeaderClose: false,
					centered: false
				})
				.then(value => {
					if (value === true) {
						this.actions("updateStatus");
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		driverSaved(dataDriver) {
			this.fetchDrivers();
			this.driverInternal = {
				id: dataDriver.id,
				fullName: dataDriver.fullName
			};
			this.hideNewDriverForm();
		},
		gmapMounted(){
			this.$refs["map-tracking-status"].createMarks(this.gMarks)
		}
	},
	props: {
		index: Number
	},
	mounted() {
		this.fetchAssignedData();
		this.fetchDrivers();
		
	},
	beforeCreate() {
		this.$options.computed = {
			...mapState("reservation", ["viewModel"]),
			ride() {
				return { ...this.viewModel.transportServices[this.index] };
			},
			supplierId() {
				return this.ride.supplierId;
			},
			driversOpts() {
				let opts = [
					{ value: "default", text: "Asignar driver default" }
				];
				this.dataDrivers.forEach(element => {
					opts.push({
						value: element.id,
						text: element.fullName
					});
				});
				return opts;
			},
			driverSelected: {
				get: function() {
					return this.driverInternal.id;
				},
				set: function(val) {
					this.driverSelectedOption = val;
				}
			},
			trackingStatusActual() {
				return this.$root.getItemFromAuxVarOpts(
					"transportServiceTrackingStatusOpts",
					this.ride.trackingStatus
				);
			},
			trackingStatusNext() {
				let opts = [
					...this.$root.auxVars.transportServiceTrackingStatusOpts
				];
				let indexActual = opts.findIndex(el => {
					return el.value == this.ride.trackingStatus;
				});

				if (this.noShow) {
					let indexNoShow = opts.findIndex(el => {
						return el.value == "noShow";
					});
					return opts[indexNoShow];
				} else {
					let nextIndex = indexActual + 1;
					return opts[nextIndex];
				}
			},
			islastStatus() {
				return (
					this.ride.trackingStatus == "finished" ||
					this.ride.trackingStatus == "noShow"
				);
			},
			logsTrackStatus(){
				return this.trackStatusLogs;
			},
			placesRide(){
				return [{...this.ride.pickup},{...this.ride.dropoff}]
			},
			gMarks(){

				let arrayDriverTrack = [];

				let pp = {...this.ride.pickup};
				pp.label   = "A";
				pp.content = pp.name;
				let dp = {...this.ride.dropoff};
				dp.label   = "B";
				dp.content = dp.name;
				arrayDriverTrack.push(pp,dp);
				
				this.trackStatusLogs.forEach((item,index)=>{
					let itemMark  = {...item};
					itemMark.label=  (index+1).toString();
					itemMark.content= item.transportServiceTrackingStatus+"<br>"+item.creationDatetimeLocal;
					arrayDriverTrack.push(itemMark);
				})

				return arrayDriverTrack;
			}
		};
	}
};
</script>

<style scoped>
.card-body {
	padding: 0.1rem !important;
}
.card-header {
	padding: 0.3rem !important;
}
</style>
